module.exports = __webpack_public_path__ + "static/img/deviceAllcountBg.41b1e2b6.png";